import { getVoicePromptInfo } from '@lib/audio';

class ViewAudio {
  constructor() {
    this.audioOut = null;
  }

  /**
   * Play a specific audio for prompts.
   */
  async play(audio, prompt, muted = false, repeat = false) {
    let promptKey = prompt;
    if (repeat) {
      if (prompt === 'left') {
        promptKey = 'leftFurther';
      } else if (prompt === 'right') {
        promptKey = 'rightFurther';
      } else if (prompt === 'smile') {
        promptKey = 'biggerSmile';
      }
    }

    const { from, to } = ViewAudio.getDuration(promptKey);
    const time = to - from;

    if (audio) {
      if (this.audioOut) {
        await this.audioOut;
      }

      // eslint-disable-next-line no-param-reassign
      audio.muted = muted;
      // eslint-disable-next-line no-param-reassign
      audio.currentTime = from;
      audio.play();

      this.audioOut = new Promise((resolve) => {
        setTimeout(() => {
          audio.pause();
          this.audioOut = null;
          resolve();
        }, time * 1000);
      });
    }
  }

  static getDuration(prompt) {
    const { durations } = getVoicePromptInfo();
    return durations[prompt];
  }
}

const singletonAudio = new ViewAudio();
export default singletonAudio;
